define('search',[
  "models/search",
  "collections/search",
  "views/search/search",
  "sandbox",
  "./content"
], function (SearchModel, SearchHits, SearchView) {
  "use strict";

  $(function () {
    var searchHits, navSearchHits;

    searchHits = new SearchHits([], { model: SearchModel });
    navSearchHits = new SearchHits([], { model: SearchModel });
    searchHits.url = $("#search").find("form").data("action");
    navSearchHits.url = searchHits.url;

    new SearchView({
      model: new SearchModel(),
      el: $("#search"),
      resultsEl: $(".search-results"),
      advancedEl: $(".advanced-search"),
      collection: searchHits
    });

    new SearchView({
      model: new SearchModel(),
      el: $("#navbar-search"),
      resultsEl: $(".narrow-search-results"),
      collection: navSearchHits
    });
  });
});

